import { selectWarehouse, updateWarehouse } from 'containers/Warehouses/warehousesSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { useParams } from 'react-router-dom'
import { contractAccess } from 'rest/urls'
import { POST } from 'rest/request'
import { useState } from 'react'

interface Body {
  applicationPinSecured: boolean
  biometricsSecured: boolean
  customPin: string | false
}

const useAccessSettingActions = () => {
  const [isSending, setSending] = useState(false)
  const { id } = useParams<warehouse.PageParams>()
  const warehouse = useReduxSelector(state => selectWarehouse(state, id))

  const dispatch = useReduxDispatch()
  const action = async (body: Partial<Body>) => {
    if (isSending) return
    try {
      setSending(true)
      const response = await POST(contractAccess(warehouse.contractId), { body })
      if (response.data) {
        const { applicationPinSecured, biometricsSecured, customPinSecured } = response.data
        dispatch(updateWarehouse({ id, values: { '2fa_access': { applicationPinSecured, biometricsSecured, customPinSecured } } }))
        setSending(false)
        return response
      } else {
        throw new Error('wrong response')
      }

    } catch (error) {
      setSending(false)
    }
  }

  return {
    isSending,
    action
  }
}

export default useAccessSettingActions